import React, { useState } from "react"
import PropTypes from "prop-types"
import { Box, IconButton, MenuItem, Menu } from "@mui/material"
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined"
import { ReactComponent as MaterialIcon } from "assets/customIcons/materiales.svg"
import { ReactComponent as ManodeobraIcon } from "assets/customIcons/manodeobra.svg"
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined"
import RecyclingIcon from "@mui/icons-material/Recycling"
import AutoDeleteOutlinedIcon from "@mui/icons-material/AutoDeleteOutlined"

const typeOptions = [
  {
    value: "coste",
    label: "Coste",
    icon: <MonetizationOnOutlinedIcon sx={{ color: "#ccc" }} />,
  },
  {
    value: "material",
    label: "Material",
    icon: <MaterialIcon sx={{ color: "#ccc", fill: "#ccc" }} />,
  },
  {
    value: "manodeobra",
    label: "Mano de obra",
    icon: <ManodeobraIcon sx={{ color: "#ccc", fill: "#ccc" }} />,
  },
  {
    value: "maquinaria",
    label: "Maquinaria",
    icon: <LocalShippingOutlinedIcon sx={{ color: "#ccc" }} />,
  },
  {
    value: "residuoAdicional",
    label: "Residuo adicional",
    icon: <RecyclingIcon sx={{ color: "#ccc" }} />,
  },
  {
    value: "residuoClasificacion",
    label: "Residuo clasificación",
    icon: <AutoDeleteOutlinedIcon sx={{ color: "#ccc" }} />,
  },
]

const getIconForType = type => {
  const option = typeOptions.find(opt => opt.value === type)
  return option ? (
    option.icon
  ) : (
    <ManodeobraIcon sx={{ color: "#ccc", fill: "#ccc" }} />
  )
}

const TypeIconWithMenu = ({ value, onChange, disabled }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)

  const handleClick = event => {
    if (!disabled) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleSelect = newValue => {
    onChange(newValue)
    handleClose()
  }

  return (
    <>
      <IconButton
        onClick={handleClick}
        size="small"
        disabled={disabled}
        sx={{ p: 0.5 }}
      >
        <Box sx={{ width: 15, display: "flex", justifyContent: "center" }}>
          {getIconForType(value)}
        </Box>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        {typeOptions.map(option => (
          <MenuItem
            key={option.value}
            onClick={() => handleSelect(option.value)}
            selected={value === option.value}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Box
                sx={{
                  width: "24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {option.icon}
              </Box>
              {option.label}
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

TypeIconWithMenu.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default TypeIconWithMenu
export { typeOptions, getIconForType }
